module.exports = __webpack_public_path__ + "img/g0018.5b979e4c.png";